<button mat-icon-button
        class="notification-btn"
        type="button"
        matTooltip="{{ 'global.notifications' | translate }}"
        matTooltipPosition="right">
        <mat-icon>notifications</mat-icon>
</button>
